import React, { useEffect, useState } from 'react';
import { Form } from 'antd';

import ChoiceLine from '../form-wrappers/choice-line';
import UntilItem from '../form-items/until-item';
import CountItem from '../form-items/count-item';

import ChoiceGroup from '../form-wrappers/choice-group';
import { RECURRENCE_ENDS } from '../../../../constants/recurrence-constants';

const EndsContainer = ({ form, selectedEnds, rootContainer }) => {
  const [ends, setEnds] = useState(null);
  const [occurrencesSuffix, setOccurrencesSuffix] = useState('occurrence');

  const defaulEndsSizes = {
    span: 24,
    offset: 0,
    prefix: {
      span: 5,
      offset: 0,
    },
    child: {
      span: 6,
      offset: 0,
    },
    suffix: {
      span: 6,
      offset: 0,
    },
  };

  useEffect(() => {
    setEnds(selectedEnds);
  }, [selectedEnds]);

  const onChangeOcurrences = (value) => {
    if (!value || value !== 1) {
      setOccurrencesSuffix('occurrences');
    } else {
      setOccurrencesSuffix('occurrence');
    }
  };

  const onChangeEndsOccurrence = (value) => {
    setEnds(value);

    switch (value) {
      case RECURRENCE_ENDS.NEVER:
      default:
        form.setFieldValue(['rules', 'count']);
        form.setFieldValue(['rules', 'until']);
        break;
      case RECURRENCE_ENDS.ON:
        form.setFieldValue(['rules', 'count']);
        break;
      case RECURRENCE_ENDS.AFTER:
        form.setFieldValue(['rules', 'until']);
        break;
    }
  };

  return (
    <Form.Item wrapperCol={{ offset: 0 }} shouldUpdate={true}>
      {() => {
        return (
          <ChoiceGroup
            itemObj={{
              name: ['rules', 'ends'],
              isRadioGroup: true,
              initialValue: ends,
              offset: 4,
              onChange: onChangeEndsOccurrence,
            }}
          >
            <ChoiceLine sizes={defaulEndsSizes} prefix={{ isRadioGroup: true, label: 'Never', value: RECURRENCE_ENDS.NEVER }} />

            <ChoiceLine sizes={defaulEndsSizes} prefix={{ isRadioGroup: true, label: 'On', value: RECURRENCE_ENDS.ON }}>
              <UntilItem
                rootContainer={rootContainer}
                disabled={ends !== RECURRENCE_ENDS.ON}
                required={ends === RECURRENCE_ENDS.ON}
                shouldUpdate={true}
              />
            </ChoiceLine>

            <ChoiceLine
              sizes={defaulEndsSizes}
              prefix={{ isRadioGroup: true, label: 'After', value: RECURRENCE_ENDS.AFTER }}
              suffix={occurrencesSuffix}
            >
              <CountItem
                onChange={onChangeOcurrences}
                disabled={ends !== RECURRENCE_ENDS.AFTER}
                required={ends === RECURRENCE_ENDS.AFTER}
                shouldUpdate={true}
              />
            </ChoiceLine>
          </ChoiceGroup>
        );
      }}
    </Form.Item>
  );
};

export default EndsContainer;
